import { Routes } from '@angular/router';

import { ContentLayoutComponent } from './core/layout/content/content-layout.component';
import { CONTENT_ROUTES } from './shared/routes/content-layout.routes';
import { AuthGuard } from './core/auth/auth.guard';
import { FullLayoutComponent } from './core/layout/full/full-layout.component';
import { Full_ROUTES } from './shared/routes/full-layout.routes';
import { PageNotFoundComponent } from './pages/content-pages/404/page-not-found.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'vincular-usuario',
        pathMatch: 'full'   
    },
    { 
        path: '', 
        component: FullLayoutComponent,    
        data: { 
        title: 'Full Views', 
        breadcrumbs: true,
        text: 'Home'
        },     
        children: Full_ROUTES, 
        canActivate: [ AuthGuard ] 
    },
    { path: '', component: ContentLayoutComponent, data: { title: 'Content Views' }, children: CONTENT_ROUTES },    
    { path: '**', component: PageNotFoundComponent }
];
